import { Caption1, Title3, makeStyles, tokens } from '@fluentui/react-components';

import { TChangePlan } from '../../models';
import { formatDate, getPlanSummary } from '../../utils';

const useStyles = makeStyles({
  row: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: tokens.spacingHorizontalM,
    '@media (max-width: 720px)': { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
  },
  tile: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  label: { color: tokens.colorNeutralForeground3 },
  attention: { color: tokens.colorStatusDangerForeground1 },
});

// One compact summary row (prompt Part 7). Only items requiring attention are
// highlighted; the rest stay calm.
export const PlanSummaryRow = ({ plan }: { plan: TChangePlan }) => {
  const classes = useStyles();
  const summary = getPlanSummary(plan);

  const tiles: { label: string; value: string; attention?: boolean }[] = [
    { label: 'Tasks', value: String(summary.tasks) },
    { label: 'Unassigned', value: String(summary.unassigned), attention: summary.unassigned > 0 },
    { label: 'Missing due date', value: String(summary.missingDueDate), attention: summary.missingDueDate > 0 },
    { label: 'Target date', value: summary.targetDate ? formatDate(summary.targetDate) : 'Not set' },
  ];

  return (
    <div className={classes.row}>
      {tiles.map((tile) => (
        <div key={tile.label} className={classes.tile}>
          <Title3 className={tile.attention ? classes.attention : undefined}>{tile.value}</Title3>
          <Caption1 className={classes.label}>{tile.label}</Caption1>
        </div>
      ))}
    </div>
  );
};
